var map = {
	"./expandAndCollapse.svg": 96681,
	"./folderClose.svg": 33711,
	"./folderOpen.svg": 21009,
	"./more.svg": 1274,
	"./treeIcons.svg": 16381,
	"./uploads.svg": 68741
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 52196;